import React from "react";
import quoteIcon from "assets/quote.png";
import Anchor from "atom/Anchor";
import PageCenter from "atom/PageCenter";
import ProgressiveImage from "atom/ProgressiveImage";
import { Heading } from "atom/Typography";
import style from "./style.scss";
import cn from "classnames";

const Side = ({ children, pdf, label, left, lower }) => (
  <Anchor
    href={
      pdf +
      "?utm_source=optumconversation&utm_medium=weblink&utm_campaign=internal-traffic&utm_id=optumconversation-homepage"
    }
    className={cn(style.item, left ? style.left : style.right)}
  >
    <div className={cn(style.upper)}>{children}</div>
    {lower ? lower : <label> {label}</label>}
  </Anchor>
);

const HalfHalf = ({ quote, right }) => (
  <PageCenter contentClass={cn(style.content)}>
    <Side
      {...quote.link}
      left
      lower={
        <div className={cn(style.lower)}>
          <div className={cn(style.portrait)}>
            <img {...quote.image} />
            <div dangerouslySetInnerHTML={{ __html: quote.imageLabel }} />
          </div>
          <label> {quote.link.label}</label>
        </div>
      }
    >
      <img src={quoteIcon} />
      <Heading type={"h3"} className={cn(style.body)}>
        {quote.text}
      </Heading>
    </Side>
    <Side {...right.link}>
      <Heading>{right.title}</Heading>
      <div className={cn(style.body)}>{right.subtitle}</div>
      <ProgressiveImage {...right.image} />
    </Side>
  </PageCenter>
);

export default HalfHalf;
